import { render, staticRenderFns } from "./MtoSectorDetail.vue?vue&type=template&id=f2c438fe&scoped=true"
import script from "./MtoSectorDetail.vue?vue&type=script&lang=js"
export * from "./MtoSectorDetail.vue?vue&type=script&lang=js"
import style0 from "./MtoSectorDetail.vue?vue&type=style&index=0&id=f2c438fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c438fe",
  null
  
)

export default component.exports